import { graphql } from '@api/generated';
import { useLazyQuery } from '@apollo/client/react';

export const GET_CUSTOMER_CONTACTS = graphql(`
  query getCustomerContacts($tenantId: ID!, $customerId: ID!) {
    customer(tenantId: $tenantId, id: $customerId) {
      id
      name
      contacts {
        id
        type
        value
        memo
        jobRemindersEnabled
        marketingUpdatesEnabled
        invoiceStatementNotification
      }
    }
  }
`);

const useLazyGetCustomerContacts = (tenantId: string, customerId: string) => {
  const [fetchCustomerContacts, { data, loading, error }] = useLazyQuery(
    GET_CUSTOMER_CONTACTS,
    {
      fetchPolicy: 'network-only',
      variables: { tenantId, customerId },
    },
  );

  return { fetchCustomerContacts, data, loading, error };
};

export default useLazyGetCustomerContacts;
